<template>
  <v-container fluid class="pa-0">
    <generic-view
          title="Settings"
          entity_name="settings"
          :headers="headers"
        >
    </generic-view>
    <v-container fluid class="pa-5">
      <v-row>
        <v-col>
          <v-card :loading="loading">
            <v-card-title>
              Activation
            </v-card-title>
            <v-card-text>
              Controls if the tracking data coming from the mobile application should be accepted or not.
              <v-switch v-model="isActive" color="primary" label="Mobile Application Active" />
            </v-card-text>
          </v-card>
        </v-col>
        <v-col>
          <v-card>
            <div class="pa-4 grey lighten-4">
              <img height="48" src="@/assets/smartphoenix-logo.png" alt="SmartPhoenix SAL"/>
            </div>
            <v-card-title>
              About Developers
            </v-card-title>
            <v-card-text>
              Mobile Application &amp; Content Management Portal made by SmartPhoenix SAL.
            </v-card-text>
            <v-card-actions>
              <v-btn text color="green" href="https://www.smartphoenix.com/" target="_blank">
                <v-icon class="mr-2">mdi-open-in-new</v-icon>
                Website
              </v-btn>
              <v-spacer />
              <v-btn text color="primary" href="mailto:support@smartphoenix.com">
                <v-icon class="mr-2">mdi-alert-circle-outline</v-icon>
                Report a Problem
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-container>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  data() {
    return {
      isActive: false
    }
  },
  computed: {
    ...mapState('settings',['settings','loading']),
    headers(){
      return [
        {
          text:"Key",
          value:'key',
          type:'textfield'
        },
        {
          text:'Value',
          value:'value',
          type:'textfield'
        }
      ]
    }
  },
  methods: {
    ...mapActions('settings',['getSettings','updateAppActive'])
  },
  mounted() {
    if (this.settings.id == undefined) {
      this.getSettings().then(response => {
        this.isActive = response.isAppActive
      })
    } else {
      this.isActive = this.settings.isAppActive
    }
  },
  watch: {
    isActive(value) {
      if (this.isActive != this.settings.isAppActive) {
        this.updateAppActive(this.isActive).catch(_ => {
          this.isActive = !this.isActive
        })
      }
    }
  }
}
</script>